export default {
    namespaced: true,
    state: {
        sort: {},
        filter: {},
        search: '',
        pageNumber: 1,
        items: [],
        total: null,
        selectedItems: [],
    },
    getters: {
        getSort(state) {
            return state.sort;
        },
        getFilter(state) {
            return state.filter;
        },
        getSearch(state) {
            return state.search;
        },
        getPageNumber(state) {
            return state.pageNumber;
        },
        getItems(state) {
            return state.items;
        },
        getTotal(state) {
            return state.total;
        },
        getSelectedItems(state) {
            return state.selectedItems;
        },
    },
    mutations: {
        setSort(state, {column, value}) {
            if (value === null) {
                delete state.sort[column];
            } else {
                state.sort[column] = value;
            }

            state.sort = JSON.parse(JSON.stringify(state.sort));
        },
        setFilter(state, {column, value}) {
            if (value === null) {
                delete state.filter[column];
            } else {
                state.filter[column] = value;
            }

            state.filter = JSON.parse(JSON.stringify(state.filter));
        },
        setSearch(state, value) {
            state.search = value;
        },
        setPageNumber(state, value) {
            state.pageNumber = value;
        },
        setItems(state, value) {
            state.items = value;
        },
        setTotal(state, value) {
            state.total = value;
        },
        addSelectedItem(state, item) {
            state.selectedItems.push(item);
        },
        removeSelectedItem(state, id) {
            let item = state.selectedItems.find(item => {
                return item.id === id;
            });
            let idx = state.selectedItems.indexOf(item);
            state.selectedItems.splice(idx, 1);
        },
        clearSelectedItems(state) {
            state.selectedItems = [];
        },
        clearIndexTable(state) {
            state.sort = {};
            state.filter = {};
            state.search = '';
            state.pageNumber = 1;
            state.items = [];
            state.total = null;
            state.selectedItems = [];
            state.deleted = false;
        }
    },
    actions: {},
}
